const config = {
  backendUri: process.env.VUE_APP_BACKEND_BASE_URI || location.origin,
  financialOfficerId:
    process.env.VUE_APP_FINANCIAL_OFFICER_ID ||
    "2b120f78-1bd9-40f8-b69f-9a0800799c2f",
};

export default config;
